/* tslint:disable */
/* eslint-disable */
export enum WorkflowStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published',
}
